import { create } from 'zustand';
import dayjs from 'dayjs';

const usePurchaseStore = create((set) => ({
  // Estado inicial
  purchase: {
    date: dayjs(),
    receipt: '',
    provider: null,
    items: [],
    payments: [],
    total: 0,
    debt: 0,
    deposit: null,
  },

  purchaseItem: {
    product: null,
    price: '',
    quantity: '',
    discount_surcharge: '',
    selected_unit: '',
  },

  paymentItem: {
    finance_types_payment: null,
    amount: '',
  },

  // Acciones
  setPurchase: (purchase) => set({ purchase }),
  setPurchaseItem: (purchaseItem) => set({ purchaseItem }),
  setPaymentItem: (paymentItem) => set({ paymentItem }),

  // Acciones específicas
  updatePurchase: (updates) => set((state) => ({
    purchase: { ...state.purchase, ...updates }
  })),

  addItem: (item) => set((state) => ({
    purchase: {
      ...state.purchase,
      items: [...state.purchase.items, item]
    }
  })),

  removeItem: (index) => set((state) => ({
    purchase: {
      ...state.purchase,
      items: state.purchase.items.filter((_, i) => i !== index)
    }
  })),

  addPayment: (payment) => set((state) => ({
    purchase: {
      ...state.purchase,
      payments: [...state.purchase.payments, payment]
    }
  })),

  removePayment: (index) => set((state) => ({
    purchase: {
      ...state.purchase,
      payments: state.purchase.payments.filter((_, i) => i !== index)
    }
  })),

  resetPurchaseItem: () => set({
    purchaseItem: {
      product: null,
      price: '',
      quantity: '',
      discount_surcharge: '',
      selected_unit: '',
    }
  }),

  resetPaymentItem: () => set({
    paymentItem: {
      finance_types_payment: null,
      amount: '',
    }
  }),

  resetPurchase: () => set({
    purchase: {
      date: dayjs(),
      receipt: '',
      provider: null,
      items: [],
      payments: [],
      total: 0,
      debt: 0,
      deposit: null,
    },
    purchaseItem: {
      product: null,
      price: '',
      quantity: '',
      discount_surcharge: '',
      selected_unit: '',
    },
    paymentItem: {
      finance_types_payment: null,
      amount: '',
    }
  })
}));

export default usePurchaseStore; 